import gql from 'graphql-tag';

export const ORGANIZATION_CONFIG = gql`
  query {
    organization(clientType: PATIENT_PORTAL) {
      config {
        generalConfig {
          redirectPatientToNearestAppointment
          isMyAccountFeatureEnabled
          patientEmail
          externalIdName {
            locale
            value
          }
          externalIdNamePlaceholder {
            locale
            value
          }
          userValidation {
            admin {
              externalIdRegexp
              primaryField
              secondaryFields
              requiredFields
              birthDateFormat
            }
            clinician {
              externalIdRegexp
              primaryField
              secondaryFields
              requiredFields
              birthDateFormat
            }
            patient {
              externalIdRegexp
              primaryField
              secondaryFields
              requiredFields
              birthDateFormat
            }
          }
          templateConfigs {
            patientEmptyListPlaceholderTemplate
          }
        }
        appointmentConfig {
          hideArchive
        }
        fileManagerConfig {
          fileType
          mimeTypeSettings {
            mimeType
            maxSizeBytes
          }
        }
        defaultPhoneCountryCode
      }
    }
  }
`;
